export const Capitalize = (data: string) => {
  return data
    .replace("_", " ")
    .replace("_", " ")
    .split(" ")
    .map((name: string) => name.charAt(0).toUpperCase() + name.slice(1) + " ");
};
